// OAIP-44 — suggested role placeholders for project-template subtasks.
//
// Roles are FREE TEXT per template: a template author can type any role name on
// a subtask. This list only seeds the AutoComplete in the template editor so
// common roles are one click away. The distinct set of roles a given template
// actually uses is derived from its subtasks at apply time and mapped to real
// users in the convert-intake modal — there is no global, enforced role list.
//
// Keep this in sync with `DEFAULT_TEMPLATE_ROLE_SUGGESTIONS` in
// `functions/services/constants.py` (suggestions only; not authoritative).
export const DEFAULT_TEMPLATE_ROLE_SUGGESTIONS: string[] = [
  "Project Lead",
  "Tech Lead",
  "Agency Sponsor",
  "Vendor PM",
  "Reviewer",
];
